/**
 * @description 查询机器人应用能力
 * @param {string} appId 应用id
 */
 export const fetchWecodeAppInfo = appId => {
  return fetch(`/wecode/service/innerapp/robot/ability/${appId}`, {
    method: "GET",
  });
};


/**
 * @description 删除机器人能力
 * @param {string} appId 应用id
 */
export const deleteWecodeAbility = appId => {
  return fetch(`/wecode/service/innerapp/robot/ability/${appId}`, {
    method: "DELETE",
  });
};


export const updateWecodeAppInfo = (param, appId) => {
  return fetch(`/wecode/service/innerapp/robot/ability/${appId}`, {
    method: "PUT",
    body: JSON.stringify(param)
  });
};
